import { render, staticRenderFns } from "./DatosProductosComponent.vue?vue&type=template&id=7d71d308&scoped=true"
import script from "./DatosProductosComponent.vue?vue&type=script&lang=js"
export * from "./DatosProductosComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosProductosComponent.vue?vue&type=style&index=0&id=7d71d308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71d308",
  null
  
)

export default component.exports